import { createContext, useContext } from "react";

export const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

/**
 * hasAuthToken, synchronous, race-proof "is the user actually logged in"
 * check. The React context value (`useApp().user`) briefly returns null
 * across route transitions and hard refreshes which was popping the
 * AuthGate ("Ready to start your journey?") for already-logged-in users.
 * If a JWT is in storage, we treat the user as authenticated regardless
 * of context hydration state. Backend will reject invalid tokens.
 */
export const hasAuthToken = () => {
  try {
    return !!(
      localStorage.getItem("isaiah_token") ||
      localStorage.getItem("token") ||
      sessionStorage.getItem("isaiah_token") ||
      sessionStorage.getItem("token")
    );
  } catch { return false; }
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const IMG = {
  heroBg: "https://static.prod-images.emergentagent.com/jobs/2655ff48-49c5-422b-8d5b-f48ba8390fac/images/fcb21cc05e87a43bc09962460f6ad4956eb70b5377f451d7abb07144ef713613.png",
  worldMap: "https://static.prod-images.emergentagent.com/jobs/2655ff48-49c5-422b-8d5b-f48ba8390fac/images/baa01ca6c855e1162f55f184d077dbbaf3feec4ebe5331a9c7020568c33dde0d.png",
  learnBg: "https://static.prod-images.emergentagent.com/jobs/2655ff48-49c5-422b-8d5b-f48ba8390fac/images/e305a3cc57bee416327e39001fb1e8e7b3e30de4726ee5411b2fb6b62d28f289.png",
  arcadeBg: "https://static.prod-images.emergentagent.com/jobs/2655ff48-49c5-422b-8d5b-f48ba8390fac/images/24a6c5ab53516839bc23dc11a1363c613c71b062c3fca4dadf17db28ea6b35ba.png",
  logo: "/assets/logo-new.webp",
  isaiahAvatar: "/assets/isaiah/poses/headshot.png",
  isaiahHero: "/assets/isaiah/poses/idle.png",
  isaiahLearn: "/assets/isaiah/poses/idle.png",
  isaiahAdventures: "/assets/isaiah/poses/idle.png",
  isaiahExplorer: "/assets/isaiah/poses/idle.png",
  realIsaiah: "https://customer-assets.emergentagent.com/job_content-audit-16/artifacts/dzl1dyrm_IMG_0679.jpeg",
  refPickAdventure: "https://customer-assets.emergentagent.com/job_content-audit-16/artifacts/dbk1rtxm_image_eb4181e7-6adc-483f-92db-9b184b39ee84.png",
};
